import { Moon, Sun } from "lucide-react";
import { useTheme } from "next-themes";

export default function ThemeToggle({ className = "dl-icon-button" }) {
  const { theme, setTheme, resolvedTheme } = useTheme();
  const current = resolvedTheme || theme || "light";
  const isDark = current === "dark";

  return (
    <button
      type="button"
      className={className}
      onClick={() => setTheme(isDark ? "light" : "dark")}
      title={isDark ? "Switch to light mode" : "Switch to dark mode"}
      aria-label="Toggle theme"
    >
      {isDark ? <Sun /> : <Moon />}
    </button>
  );
}


